module.exports = __webpack_public_path__ + "static/media/092-plugin.a63c68c1.svg";